import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AccessLevels } from '@bciti/types';
import { IPermissionScope } from 'src/app/auth/auth.model';
import { userScopesSelector } from 'src/app/user/store/user.selectors';
import { State } from '../../../store';

@Component({
    selector: 'app-permit-dashboard',
    templateUrl: './permit-dashboard.component.html',
    styleUrls: ['./permit-dashboard.component.scss'],
})
export class PermitDashboardComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    private userScopes: IPermissionScope[] = [];

    get canViewSettings(): boolean {
        return this.userScopes.some((scope) => scope.resource === 'settings' && scope.accessLevel === AccessLevels.WRITE);
    }

    constructor(private store: Store<State>) {}

    ngOnInit(): void {
        this.store
            .select(userScopesSelector)
            .pipe(takeUntil(this.destroy$))
            .subscribe((scopes: IPermissionScope[]) => {
                this.userScopes = scopes || [];
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
